import * as ActionTypes from "../actions/ActionTypes";
import initialState from "./InitialState";

export const DoctorProfileReducer = function (state = initialState.doctorProfile, action: any) {
    switch (action.type) {
        case ActionTypes.FETCH_DOC_PROFILE_SUCCESS:
            return Object.assign({}, action.doctorProfile);
        case ActionTypes.UPDATE_DOC_PROFILE_SUCCESS:
            return Object.assign({}, action.doctorProfile);
        default:
            return state;
    }
};